<div class="wrapper">
  <div class="row d-none">
    <div class="col-md-12">
      <div class="caption lb-caption">
        <i class="glyphicon glyphicon-asterisk"></i>
        <span class="caption-subject">{{ 'activateInventory.selector.title' | translate }}</span>
      </div>
    </div>

  </div>
</div>

<div class="inventory-selector">
  <!-- Header -->
  <div class="selector-header">
    <h3>{{ 'activateInventory.selector.title' | translate }}</h3>
    <p class="text-muted">{{ 'activateInventory.selector.subtitle' | translate }}</p>
  </div>

  <div class="selection-feedback">
    <p>
      <i class="fas fa-info-circle me-2 text-primary"></i>
      <span id="selection-text">{{ 'activateInventory.selector.prompt' | translate }}</span>
    </p>
  </div>
  <!-- Inventory Cards -->
  <div class="cards-container">
    <!-- General Inventory -->
    <div class="inventory-card d-flex flex-row" *ngFor="let inventory of inventoryList">
      <a class="d-flex flex-row" (click)="setGlobalDispensary(inventory.StoreId)">
        <div class="card-icon">
          <i class="fas fa-boxes"></i>
        </div>
        <div>
          <h6 class="card-title">{{inventory.Name}}</h6>
          <p class="card-subtitle">{{ 'activateInventory.selector.cardSubtitle' | translate }}</p>
        </div>
      </a>
    </div>
  </div>
</div>
